// eslint-disable-next-line import/no-unresolved
class FixedBar extends HTMLElement {
  constructor () {
    super()

    this.fixedButton = this.querySelector('.prd-FixedBar')
    this.productButton = document.querySelector('.prd-Details_Button')

    this.isTicking = false

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.setupListeners()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    if (this.isAboveViewport() && !this.isInViewport()) {
      // Show the bar when the button is above the fold.
      this.fixedButton.setAttribute('aria-hidden', false)
      this.fixedButton.classList.add('prd-FixedBar-showButton')
    } else {
      // Hide the bar in other cases.
      this.fixedButton.setAttribute('aria-hidden', true)
      this.fixedButton.classList.remove('prd-FixedBar-showButton')
    }
  }

  isInViewport () {
    const rect = this.productButton.getBoundingClientRect()

    const isElInViewport =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    return isElInViewport
  }

  isAboveViewport () {
    // Check if the button is above the fold (above the top of the viewport).
    const rect = this.productButton.getBoundingClientRect()

    return rect.bottom < 0
  }
}

customElements.define('fixed-bar', FixedBar)
